import '../applied_filter_view.js.coffee'
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.AppliedKeywordsView extends Monitoring.Views.SocialContents.Filters.AppliedFilterView
  template: JST["backbone/templates/monitoring/filters/keywords/applied_keyword_filter"]
  appliedKeywordTemplate: JST["backbone/templates/monitoring/filters/keywords/applied_keyword"]
  name: 'keywords'
  alias: 'Keywords'
  hasLogicSelector: true

  render: ->
    @$el.html(@template(self: @))
    @allowClearFilter() unless @unmodifiableByModerators
    @$el.find('#primary_keywords').html(@appliedKeywordTemplate(self: @, applied_keywords: @_get(@withPrefix('primary_keywords')))) if @_get(@withPrefix('primary_keywords'))?.length > 0
    if @_get(@withPrefix('secondary_keywords'))?.length > 0
      @$el.find('#secondary_keywords').html(@appliedKeywordTemplate(self: @, applied_keywords: @_get(@withPrefix('secondary_keywords'))))
      @$el.find('#applied-and-logic-span').show()
    if @_get(@withPrefix('excluded_keywords'))?.length > 0
      @$el.find('#excluded_keywords').html(@appliedKeywordTemplate(self: @, applied_keywords: @_get(@withPrefix('excluded_keywords'))))
      @$el.find('#applied-exclude-logic-span').show()
    @

  getDescription: (value) ->
    value

  removeFilter: (value, list) ->
    @searchQuery.removePrimaryKeyword(value)   if list == @withPrefix('primary_keywords')
    @searchQuery.removeSecondaryKeyword(value) if list == @withPrefix('secondary_keywords')
    @searchQuery.removeExcludedKeyword(value)  if list == @withPrefix('excluded_keywords')

  clear: =>
    @searchQuery.resetField(@withPrefix('primary_keywords'))
    @searchQuery.resetField(@withPrefix('secondary_keywords'))
    @searchQuery.resetField(@withPrefix('excluded_keywords'))
    @_triggerQueryChanged()

  _triggerQueryChanged: =>
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)

  apply: (event) =>
    parent = $(event.currentTarget).parent().parent()
    value = $(event.target).parent().find('.hidden_value').text()
    @removeFilter(value, @withPrefix(parent.attr('id')))
    @_triggerQueryChanged()

  shouldShow: ->
    (@_get(@withPrefix('primary_keywords'))?.length > 0) ||
    (@_get(@withPrefix('secondary_keywords'))?.length > 0) ||
    (@_get(@withPrefix('excluded_keywords'))?.length > 0)

  _get: (group) ->
    @searchQuery.get(group)

  withPrefix: (search_query_field) ->
    search_query_field
